import {Component, computed, input, output} from '@angular/core';
import {Button} from 'primeng/button';
import {Option, Question} from '@app/models';

@Component({
  selector:'app-slide',
  imports: [
    Button
  ],
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss'],
})
export class SlideComponent {
  public question = input.required<Question>();
  public onSelect = output<Option>();
  public prev = output<void>();

  protected shuffledOptions = computed(() => {
    const options = [...this.question().options];
    for (let i = options.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [options[i], options[j]] = [options[j], options[i]];
    }
    return options;
  });

  protected onSelection = (response: Option) =>{
    this.onSelect.emit(response);
  }
}
